import { noop } from 'lodash';
import { memo, useCallback } from 'react';

import { Button, type ButtonProps } from '../../../general/button/Button';

type PaginationPageButtonProps = Omit<ButtonProps, 'onClick'> & {
  page: number;
  onClick?: (page: number) => void;
  isActive?: boolean;
};

export const PaginationPageButtonBase = ({
  page,
  onClick = noop,
  isActive = false,
  ...props
}: PaginationPageButtonProps) => {
  const onClickProxy = useCallback(() => onClick(page), [onClick, page]);

  return (
    <Button
      {...props}
      size={Button.SIZES.SMALL}
      onClick={onClickProxy}
      outline={!isActive}
      variant={isActive ? Button.VARIANTS.PRIMARY : Button.VARIANTS.NEUTRAL}
    >
      {`${page + 1}`}
    </Button>
  );
};

PaginationPageButtonBase.displayName = 'PaginationPageButton';

export const PaginationPageButton = memo(PaginationPageButtonBase);
